import {
	inviteRolesSchema,
	Role,
	RolesApiResponse,
	rolesApiResponseSchema,
	rolesAutoCompleteApiResponseSchema,
	RolesAutoCompleteResponse,
} from '@repo/shared/domain';
import { guardedClient as clientRequest } from '@repo/shared/helpers';

export const getAllRoles = async (): Promise<RolesApiResponse> => {
	const { body } = await clientRequest.get('/api/roles?noPagination=true', {
		schema: rolesApiResponseSchema,
	});
	return body;
};

export const getInviteRoles = async (): Promise<Role[]> => {
	const { body } = await clientRequest.get('/api/roles/invites', {
		schema: inviteRolesSchema,
	});
	return body;
};

export const getRolesForAutocomplete = async (): Promise<RolesAutoCompleteResponse> => {
	const { body } = await clientRequest.get('/api/roles/auto-complete', {
		schema: rolesAutoCompleteApiResponseSchema,
	});
	return body;
};
